<template>
  <section>
    <div class="container-fluid">
      <div class="row justify-content-end">

        <div class="col">
          <h4 class="form-head">Reports</h4>
        </div>
        <div class="col-2">
              <div class="btn btn-group btn-group-lg">
                <button class="btn btn-secondary" v-b-toggle.searchEwbs >
                  <i class="float-right fa fa-search" style="cursor: pointer">&nbsp;</i>
                </button>
              </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <b-collapse id="searchEwbs" class="mt-1" visible>
            <b-card style="background-color: #F9F9F9;">
              <div class="form-row justify-content-between">
                <div class="col-1">
                  <div class="form-group">
                    <label><strong>From Date</strong></label>  <br/>
                    <date-picker v-model="generatedDateRangeFrom" :config="optionsDt"></date-picker>

                  </div>
                </div>
                <div class="col-1">
                  <div class="form-group">
                    <label><strong>To Date</strong></label>  <br/>
                    <date-picker v-model="generatedDateRangeTo" :config="optionsDt"></date-picker>

                  </div>
                </div>
                <div class="col-2 ml-2">
                  <div class="form-group">
                    <label><strong>Type</strong></label> <br/>
                    <div class="form-check ">
                      <input class="form-check-input" type="radio" v-model="ewbType" name="type" id="incoming" value="consigneeGst">
                      <label class="form-check-label" for="incoming">Incoming EWaybills</label>
                    </div>
                    <div class="form-check ">
                      <input class="form-check-input" type="radio" v-model="ewbType" name="type" id="outgoing" value="consignorGst">
                      <label class="form-check-label" for="outgoing">Outgoing EWaybills</label>
                    </div>
                  </div>
                </div>
                <div class="col-2">
                  <div class="form-group">
                    <!-- credentials -->
                    <label for="creds"><strong>States</strong></label>
                    <select multiple v-model="states" id="creds" class="form-control">
                      <option v-for="c of creds" :key="c.id" :value="c.gstNumber">{{c.state}} ({{c.gstNumber}})</option>
                    </select>
                  </div>
                </div>
                <div class="col-1">
                  <div class="form-group">
                    <label class="mt-5"></label>
                    <button class="btn btn-primary" type="submit" @click="getReport"><i class="fa fa-eye"></i> View Report</button>
                  </div>
                </div>
                <div class="col-2">
                  <div class="form-group">
                    <label class="mt-3"></label>
                    <form :action="csvDownloadUrl" method="post">
                      <input type="hidden" name="json" v-model="searchAsJson" />
                      <button type="submit" class="btn btn-info"><i class="fa fa-download"></i> Download Excel
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </b-card>
          </b-collapse>
        </div>
      </div>
      <br/>
      <!-- table -->
      <div class="row">
        <div class="col-12">
          <table class="table table-hover">
            <thead class="thead-light">
            <tr>
              <th>EWB No & Date</th>
              <th>Doc No & Date</th>
              <th>Consignor & Consignee</th>
              <th>Transporter</th>
              <th>&nbsp;</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="e of ewbs" :key="e.id" style="cursor: pointer" v-bind:class="tblClass(e)">
              <td>
                {{e.ewb}}
              </td>
              <td>
                {{e.invoiceNo}} <br/>
                {{e.invoiceDt | date}} <br/>
                <i class="fal fa-rupee-sign"></i> {{e.invoiceVal}}
              </td>
              <td>
                {{e.consignorGst}}
                <br/>
                {{e.consigneeGst}}
              </td>
              <td>
                {{e.transporterId}} <br/>
                {{e.awb}}
              </td>
              <td>
                <div class="btn-group btn-group-md mt-3">
                  <button class="btn btn-info"
                          v-b-modal.detView
                          @click="selectedEWB(e, $event)"
                          v-b-tooltip.hover title="View EWaybill">
                    <i class="fa fa-eye"></i>
                  </button>
                  <button class="btn btn-danger"
                          @click="cancelEWaybill(e, $event)"
                          v-b-tooltip.hover title="Cancel EWaybill"
                          :disabled="e.cancelled === true">
                    <i class="fa fa-times"></i>
                  </button>
                  <button class="btn btn-primary"
                          v-b-tooltip.hover title="Update Part-B"
                          @click="updatePartB(e, $event)">
                    <i class="fa fa-truck"></i>
                  </button>
                  <button class="btn btn-secondary"
                          v-b-tooltip.hover title="Change Transporter"
                          @click="changeTransporter(e, $event)">
                    <i class="fa fa-person-carry"></i>
                  </button>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
          <b-modal id="detView" title="E-Waybill Details" size="lg" centered>
            <basic-e-w-b-details v-bind:ewaybill="selectedEWaybill"></basic-e-w-b-details>
            <h4 class="form-head">History</h4>
            <div class="row">
              <div class="col">

                <h5>Part-B History</h5>
                <ul class="list-group">
                  <li class="list-group-item" v-for="h of partBHistory" :key="h.id">
                    {{h.date | datetime}} @ {{h.location}}
                  </li>
                </ul>
              </div>
              <div class="col">
                <h5>Docket History</h5>
                <ul class="list-group">
                  <li class="list-group-item" v-for="h of docketHistory" :key="h.id" v-if="h.date">
                    {{h.date | datetime}} @ {{h.location}}
                  </li>
                </ul>
              </div>
            </div>
          </b-modal>
          <b-modal id="podView" title="Docket POD" size="lg" centered>
            <basic-e-w-b-details v-bind:ewaybill="selectedEWaybill"></basic-e-w-b-details>
            <h4 class="form-head">POD</h4>
            <div class="row justify-content-center">
              <div class="col-10">
                <img :src="selectedEWaybill.podUrl" alt="POD">
              </div>
            </div>
          </b-modal>
          <cancel-e-w-b v-if="showCancelDialog && canCancel"
                        v-on:dialogClosed="cancelDialogClosed"
                        v-on:cancelComplete="cancelComplete"
                        v-bind:credential="credential"
                        v-bind:ewaybill="eWaybillToCancel"></cancel-e-w-b>
          <update-part-b v-if="showPartBUpdateDialog"
                         v-on:dialogClosed="updatePartBDialogClosed"
                         v-on:cancelComplete="updateComplete"
                         v-bind:credential="credential"
                         v-bind:ewaybill="eWaybillToUpdate"></update-part-b>
          <change-transporter v-if="showChangeTransporterDialog"
                              v-on:dialogClosed="changeTransporterDialogClosed"
                              v-on:cancelComplete="changeComplete"
                              v-bind:credential="credential"
                              v-bind:ewaybill="eWaybillToChange"></change-transporter>
        </div>
      </div>

  </section>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import CancelEWB from '@/components/shared/CancelEWB'
import UpdatePartB from '@/components/shared/UpdatePartB'
import ChangeTransporter from '@/components/shared/ChangeTransporter'
import BasicEWBDetails from '@/components/shared/BasicEWBDetails'

export default {
  name: 'ReportPage',
  components: {ChangeTransporter, UpdatePartB, CancelEWB, BasicEWBDetails},
  created: function () {
    this.$store.dispatch('isLoggedIn').then(() => {
      if (this.$store.state.loggedIn) {
        this.loadCreds()
      } else {
        this.$router.push('/login')
      }
    }, _ => {
      console.error('isLoggedIn Failed, lets go to login')
      this.$router.push('login')
    })
  },
  data () {
    return {
      generatedDateRangeFrom: moment().subtract(1, 'days').toDate(),
      generatedDateRangeTo: moment().toDate(),
      creds: [],
      states: [],
      options: [
        {text: 'Yes', value: true},
        {text: 'No', value: false},
        {text: '<i class="fa fa-times"></i>', value: null}
      ],
      optionsDt: {
        format: 'YYYY-MM-DD',
        useCurrent: false,
        keepOpen: false,
        collapse: false,
        toolbarPlacement: 'bottom',
        showTodayButton: false
      },
      ewbs: [],
      actualEwbs: [],
      f: {
        ewbNo: '',
        trackingNo: '',
        invoiceNo: '',
        noPartB: null,
        pod: null,
        cancelled: null,
        expired: null,
        duplicate: null,
        delivered: null
      },
      selectedEWaybill: {},
      eWaybillToCancel: {},
      eWaybillToUpdate: {},
      eWaybillToChange: {},
      partBHistory: [],
      docketHistory: [],
      showCancelDialog: false,
      showPartBUpdateDialog: false,
      showChangeTransporterDialog: false,
      transportersList: [],
      ewbType: 'consignorGst'
    }
  },
  computed: {
    canCancel: function () {
      return this.$store.state.user.admin || this.$store.state.user.permissions.indexOf('CANCEL_EWB') >= 0
    },
    searchAsJson: function () {
      let q = {
        dateFrom: moment(this.generatedDateRangeFrom).format('YYYY-MM-DD'),
        dateTo: moment(this.generatedDateRangeTo).format('YYYY-MM-DD'),
        creds: this.states,
        type: this.ewbType
      }
      return JSON.stringify(q)
    },
    csvDownloadUrl: function () {
      return `${process.env.API_URL}/app/ewb/reports?csv=true&x-auth-token=${this.$store.state.accessToken}`
    }
  },
  methods: {
    toggleFilter: function () {
      this.f.filter = !this.f.filter
    },
    loadCreds: function () {
      axios.get('/app/cred')
        .then(response => {
          this.creds = response.data
        }, error => {
          console.error('error in loading creds', error)
        })
    },
    getReport: function () {
      let q = {
        dateFrom: moment(this.generatedDateRangeFrom).format('YYYY-MM-DD'),
        dateTo: moment(this.generatedDateRangeTo).format('YYYY-MM-DD'),
        creds: this.states,
        type: this.ewbType
      }
      this.f = {
        ewbNo: '',
        trackingNo: '',
        invoiceNo: '',
        noPartB: null,
        cancelled: null,
        expired: null,
        duplicate: null,
        delivered: null,
        pod: null,
        filter: false
      }
      axios.post('/app/ewb/reports', q)
        .then(response => {
          this.actualEwbs = response.data
          this.filterReport()
          console.log('test is here')
        }, error => {
          console.error('Error in Searching EWB', error)
        })
    },
    tblClass: function (e) {
      return e.cancelled === true ? 'table-warning' : ''
    },
    clearReport: function () {
      this.f = {
        ewbNo: '',
        trackingNo: '',
        invoiceNo: '',
        noPartB: null,
        cancelled: null,
        expired: null,
        duplicate: null,
        delivered: null,
        pod: null,
        filter: false
      }
      this.ewbs = this.actualEwbs
    },
    filterReport: function () {
      let f = this.f
      if (f.filter) {
        console.log('Filtering', this.actualEwbs.length, 'Part-B', f.noPartB, 'Cancelled', f.cancelled, 'Expired', f.expired, 'Duplicate', f.duplicate, 'Delivered', f.delivered, 'Pod', f.pod)
        let textFilteredEwbs = this.actualEwbs.filter(e => {
          if (f.invoiceNo.length === 0) return true
          else return e.invoiceNo.toUpperCase().indexOf(f.invoiceNo.toUpperCase()) > -1
        }).filter(e => {
          if (f.ewbNo.length === 0) return true
          else return e.ewb.indexOf(this.ewbNo) > -1
        }).filter(e => {
          if (f.trackingNo.length === 0) return true
          else return e.awb.indexOf(this.trackingNo) > -1
        })
        console.log('text filtered ewbs', textFilteredEwbs.length)
        let cancelledFilterEwbs = textFilteredEwbs.filter(e => {
          if (f.cancelled == null) return true
          if (f.cancelled) return e.cancelled === true
          else return e.cancelled === null || e.cancelled === false
        })
        console.log('cancelled filtered ewbs', cancelledFilterEwbs.length)
        let partBFilteredEwbs = cancelledFilterEwbs.filter(e => {
          if (f.noPartB == null) return true
          if (f.noPartB) return e.vehicleUpdatedOn === null
          else return e.vehicleUpdatedOn !== null
        })
        console.log('partb filtered ewbs', partBFilteredEwbs.length)
        let deliveredFilterEwbs = partBFilteredEwbs.filter(e => {
          if (f.delivered == null) return true
          if (f.delivered) return e.deliveryStatus === 'DELIVERED'
          else return e.deliveryStatus !== 'DELIVERED'
        })
        console.log('delivery status filtered ewbs', deliveredFilterEwbs.length)
        let podFilterEwbs = deliveredFilterEwbs.filter(e => {
          if (f.pod == null) return true
          if (f.pod) return e.podUrl !== null
          else return e.podUrl === null
        })
        console.log('pod filtered ewbs', podFilterEwbs.length)
        let expiredFilterEwbs = podFilterEwbs.filter(e => {
          if (f.expired == null) return true
          if (f.expired) {
            // asking only for expired ewaybills
            if (e.validTill) {
              const validTill = moment(e.validTill)
              const endDate = moment()
              const duration = moment.duration(validTill.diff(endDate))
              const hours = duration.asHours()
              console.log(e.ewb, f.expired, validTill.format('DD/MM/YYYY HH:mm'), hours)
              return hours < 0
            } else {
              // no validity found, consider them as un-expired
              return true
            }
          } else {
            // asking for not expired
            if (e.validTill) {
              const validTill = moment(e.validTill)
              const endDate = moment()
              const duration = moment.duration(validTill.diff(endDate))
              const hours = duration.asHours()
              console.log(e.ewb, f.expired, validTill.format('DD/MM/YYYY HH:mm'), hours)
              return hours > 0
            } else {
              // no validity found, consider them as un-expired
              return false
            }
          }
        })
        console.log('After applying expired', expiredFilterEwbs.length)
        if (f.duplicate) {
          const invoiceNumbers = this.expiredFilterEwbs.map(item => item.invoiceNo)
          this.ewbs = expiredFilterEwbs.filter(e => {
            return invoiceNumbers.reduce(function (n, val) {
              return n + (val === e.invoiceNo)
            }, 0) > 1
          }).sort((a, b) => {
            return a.invoiceNo.localeCompare(b.invoiceNo)
          })
        } else {
          this.ewbs = expiredFilterEwbs
        }
      } else {
        console.log('No Filter')
        this.ewbs = this.actualEwbs
      }
    },
    selectedEWB: function (e, evt) {
      evt.stopPropagation()
      if (!e) return
      this.selectedEWaybill = e
      axios.get(`/app/ewb/history?ewb=${e.ewb}`)
        .then(response => {
          this.partBHistory = response.data.filter(h => h.historyType === 'EWB')
          this.docketHistory = response.data.filter(h => h.historyType === 'LOGISTICS')
        }, error => {
          console.error(`error in history fetch`, error)
        })
    },
    viewPOD: function (e, evt) {
      evt.stopPropagation()
      if (!e) return
      this.selectedEWaybill = e
    },
    cancelEWaybill: function (e, evt) {
      // prevent from opening details modal
      evt.stopPropagation()
      if (e.cancelled === true) return
      this.credential = this.creds.filter(c => c.userName === e.ewbUserName)[0]
      this.eWaybillToCancel = e
      this.showCancelDialog = true
      console.log('Cancel Dialog Must Have been Opened', this.eWaybillToCancel, this.credential)
    },
    cancelDialogClosed: function () {
      console.log('Cancel Dialog Closed')
      this.showCancelDialog = false
      this.credential = null
      this.eWaybillToCancel = null
    },
    cancelComplete: function (status) {
      console.log('cancel Complete')
      // lets reload the data
      this.getReport()
    },
    updatePartB: function (e, evt) {
      // prevent from opening details modal
      evt.stopPropagation()

      this.credential = this.creds.filter(c => c.userName === e.ewbUserName)[0]
      this.eWaybillToUpdate = e
      this.showPartBUpdateDialog = true
      console.log('Part B update Dialog Must Have been Opened', this.eWaybillToUpdate, this.credential)
    },
    updatePartBDialogClosed: function () {
      console.log('update part b dialog closed')
      this.showPartBUpdateDialog = false
      this.credential = null
      this.eWaybillToUpdate = null
    },
    updateComplete: function () {
      console.log('update complete')
      // lets reload the data
      this.getReport()
    },
    changeTransporterDialogClosed: function () {
      console.log('change transporter dialog closed')
      this.showChangeTransporterDialog = false
      this.credential = null
      this.eWaybillToChange = null
    },
    changeComplete: function () {
      console.log('change complete')
      this.getReport()
    },
    changeTransporter: function (e, evt) {
      // prevent from opening details modal
      evt.stopPropagation()

      this.credential = this.creds.filter(c => c.userName === e.ewbUserName)[0]
      this.eWaybillToChange = e
      this.showChangeTransporterDialog = true
      console.log('Change transporter Dialog Must Have been Opened', this.eWaybillToUpdate, this.credential)
    }
  }
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ReportPage.vue